const swissLottoLogoImage = {
  src: '/incoming/21350961-v0-swisslotto-logo.png',
  alt: 'Swiss lotto logo',
  width: 111,
  height: 36,
  crops: {},
} as const

const expectedDimensions = { width: 111, height: 36 } as const

const constraints = {
  desktop: expectedDimensions,
  tablet: expectedDimensions,
  mobile: expectedDimensions,
  mobileSmall: expectedDimensions,
} as const

export { swissLottoLogoImage, constraints }
